import React from "react"

import { DeviceInfo } from "./DeviceInfo"

export const DeviceInfoContext = React.createContext<DeviceInfo | undefined>(undefined)

DeviceInfoContext.displayName = "DeviceInfoContext"
